import { NavigationStore } from '~/components/navigation/navigation-types';
import { STORE_VERSION } from '~/constants';

export const STATE_LOCAL_STORAGE_KEY = 'a-state';

export interface AppState {
	isLoggedIn: boolean;
	navigation: NavigationStore;
	version: string;
}

export const initialState: AppState = {
	isLoggedIn: false,
	navigation: {
		bookmarks: [],
		collapsed: false,
		history: [],
		searchHistory: {
			// NOTE(Jae): 2020-02-20 - WEBUI-3022
			// Adding EMPTY was to stop compilation errors but keep type-checking in place for majority of cases.
			EMPTY: [],
			MEMBER: [],
			EMPLOYER: [],
			INVESTMENT_MANAGER: [],
			ADVISER: [],
		},
	},
	version: STORE_VERSION,
};
